import {
  ESG_COBALT,
  ESG_LITHIUM,
  ESG_NICKEL,
  ESG_RARE_EARTHS,
  ESG_NATURAL_GRAPHITE,
  ESG_SYNTHETIC_GRAPHITE,
  ESG_LITHIUM_ION_BATTERIES,
} from '~/constants/services/esg'
import {
  COBALT,
  LITHIUM,
  NICKEL,
  NATURAL_GRAPHITE,
  SYNTHETIC_GRAPHITE,
  RARE_EARTHS,
  LITHIUM_ION_BATTERIES,
  BATTERY_EMISSIONS_ANALYSER,
} from '~/constants/services/constants'

/*-------------------------------------
  Common Assets
-------------------------------------*/
export const SUSTAINABILITY_HERO_IMAGE =
  'https://res.cloudinary.com/benchmarkminerals/image/upload/v1741188119/assets/market/sustainability/lithium/0cf464c162b3ce7084cc97ed81f644f5_1_paeymo.png'

/*-------------------------------------
  Subscriptions
-------------------------------------*/
export const SUSTAINABILITY_SUBSCRIPTIONS = {
  [COBALT.slug]: ESG_COBALT.subscription,
  [NICKEL.slug]: ESG_NICKEL.subscription,
  [LITHIUM.slug]: ESG_LITHIUM.subscription,
  [NATURAL_GRAPHITE.slug]: ESG_NATURAL_GRAPHITE.subscription,
  [SYNTHETIC_GRAPHITE.slug]: ESG_SYNTHETIC_GRAPHITE.subscription,
  [RARE_EARTHS.slug]: ESG_RARE_EARTHS.subscription,
  [LITHIUM_ION_BATTERIES.slug]: ESG_LITHIUM_ION_BATTERIES.subscription,
} as const

/*-------------------------------------
  Brochure Files Info
-------------------------------------*/
export const BROCHURE_FILE_INFO = {
  [COBALT.slug]: {
    file_name: 'Cobalt Sustainability Brochure.pdf',
    category: 'cobalt-esg-brochure',
    EnvKey: 'ESGBrochureCobaltFilePdfId',
  },
  [NICKEL.slug]: {
    file_name: 'Nickel Sustainability Brochure.pdf',
    category: 'nickel-esg-brochure',
    EnvKey: 'ESGBrochureNickelFilePdfId',
  },
  [LITHIUM.slug]: {
    file_name: 'Lithium Sustainability Brochure.pdf',
    category: 'lithium-esg-brochure',
    EnvKey: 'ESGBrochureLithiumFilePdfId',
  },
  [NATURAL_GRAPHITE.slug]: {
    file_name: 'Graphite Sustainability Report Brochure - Benchmark.pdf',
    category: 'public-documents',
    EnvKey: 'ESGBrochureGraphiteFilePdfId',
  },
  [SYNTHETIC_GRAPHITE.slug]: {
    file_name: 'Graphite Sustainability Report Brochure - Benchmark.pdf',
    category: 'public-documents',
    EnvKey: 'ESGBrochureGraphiteFilePdfId',
  },
  [RARE_EARTHS.slug]: {
    file_name: 'Rare Earths Sustainability Brochure.pdf',
    category: 'rare-earths-esg-brochure',
    EnvKey: 'ESGBrochureRareEarthsFilePdfId',
  },
  [BATTERY_EMISSIONS_ANALYSER.slug]: {
    file_name: 'Battery Emissions Analyser Sustainability Brochure.pdf',
    category: 'battery-emissions-analyser-esg-brochure',
    EnvKey: 'ESGBrochureBatteryEmissionsAnalyserFilePdfId',
  },
  [LITHIUM_ION_BATTERIES.slug]: {
    file_name: 'Lithium Ion Battery Sustainability Brochure.pdf',
    category: 'lithium-ion-battery-esg-brochure',
    EnvKey: 'ESGBrochureBatteryEmissionsAnalyserFilePdfId',
  },
} as const

/*-------------------------------------
  Sustainability Indexes
-------------------------------------*/
export const SUSTAINABILITY_INDEXES = {
  [COBALT.slug]: [
    { name: 'Miners', slug: 'miners' },
    { name: 'Refiners', slug: 'refiners' },
  ],
  [NICKEL.slug]: [
    { name: 'Miners', slug: 'miners', tag: 'esg-matrix-2' },
    { name: 'Refiners', slug: 'refiners', tag: 'esg-matrix-2' },
    { name: 'Sulphate', slug: 'sulphate', tag: 'esg-matrix-2' },
  ],
  [LITHIUM.slug]: [
    { name: 'Mined', slug: 'mined' },
    { name: 'Chemical', slug: 'chemical' },
  ],
  [NATURAL_GRAPHITE.slug]: [
    {
      name: 'Natural',
      slug: 'flake',
    },
  ],
  [SYNTHETIC_GRAPHITE.slug]: [
    {
      name: 'Synthetic',
      slug: 'synthetic',
      tag: 'esg-matrix-2',
    },
  ],
  [RARE_EARTHS.slug]: [
    { name: 'Miners', slug: 'miners' },
    { name: 'Refiners', slug: 'refiners' },
  ],
} as const
